import React, {useState} from "react";
import classnames from "classnames";
import "./index.scss";
import {connect} from "react-redux";
import IconButton from "../IconButton";
import ConfirmDialog from "../ConfirmDialog";
import {createAction} from "../../../utils/sagaHelper";
import {getTranslateTitle} from "../../../utils/objects-util.js";
import i18n from "../../../i18n.js";

const SectionItemButton = ({action, column, item}) => {
    const translateTitle = getTranslateTitle(column.label);
    const additionalInformation = i18n.exists(column.label + '_TOOLTIP') ? i18n.t(column.label + '_TOOLTIP') : ''
    const [isShow, setIsShow] = useState(false);

    const handleOnClick = () => {
        return new Promise(resolve => {
            action(column.clickAction, item[column.accessor]);
            resolve();
            setIsShow(false);
        })
    }

    const handleOnOpen = () => {
        if(column.isDisableConfirmDialog) {
            handleOnClick();
            return;
        }
        return new Promise(resolve => {
            setIsShow(true);
            resolve()
        })
    };

    const handleOnClose = () => {
        return new Promise(resolve => {
            setIsShow(false);
            resolve()
        })
    };


    return (
        <div className={classnames("push-message", {pushMessageIcon: (!!column.iconName && column.showPushMessageIcon), fixHeight: column.fixHeight })}>
            <IconButton text={translateTitle} iconName={column.iconName} isIcon={false} onClick={handleOnOpen}/>
            {additionalInformation && (
                <div className={'tooltip-icon'}>
                    <IconButton isIcon iconName={"question"} tooltipText={'additionalInformation'}/>
                </div>
            )}
            {isShow && (<ConfirmDialog handleOnCancel={handleOnClose} handleOnConfirm={handleOnClick}/>)}
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        action: (action, data) => dispatch(createAction(action, data))
    }
}

export default connect(null, mapDispatchToProps)(SectionItemButton);
